var _defs, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _circle4, _circle5, _circle6, _line, _circle7, _line2, _circle8, _line3, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartiot4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "panelGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 92,
    height: 84,
    rx: 10,
    fill: "#EFF6FF",
    stroke: "#93C5FD",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 92,
    height: 18,
    rx: 10,
    fill: "url(#panelGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    r: 3,
    fill: "#FACC15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 31,
    r: 3,
    fill: "#FACC15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 31,
    r: 3,
    fill: "#FACC15"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 22,
    height: 54,
    rx: 8,
    fill: "#DBEAFE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 58,
    r: 3.5,
    fill: "#3B82F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 70,
    r: 3.5,
    fill: "#3B82F6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 82,
    r: 3.5,
    fill: "#3B82F6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 58,
    x2: 102,
    y2: 58,
    stroke: "#93C5FD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 58,
    r: 6,
    fill: "#22C55E"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 74,
    x2: 102,
    y2: 74,
    stroke: "#93C5FD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 74,
    r: 6,
    fill: "#FACC15"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 90,
    x2: 102,
    y2: 90,
    stroke: "#93C5FD",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 6,
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartiot4);
export default __webpack_public_path__ + "static/media/smartiot_4.c1a395d0b75a8f8af79d3d23cea66b5b.svg";
export { ForwardRef as ReactComponent };